import { createContext } from 'react';

export const EditUserAgenciesContext = createContext();
